export const POST_ATF_USER_PERMISSION = "updatePostATF";
export const POST_ATF_LOAN_STATUS_LIST = ["AGREED", "FUNDED"]